import React from 'react'

function TermsEN() {
  return (
    <>
      <div className="paragraph-2">
        <p>
          These T&Cs apply to any contract sold by the company Skeepers Inc. For
          any contract concluded with the company VideoAgency whose head office
          is located in Paris, please refer to the T&Cs accessible by following
          the following link: <a href="/terms?locale=fr-FR">EU T&Cs</a>
        </p>
      </div>

      <p className="heading-1">GENERAL TERMS OF USE</p>

      <div className="paragraph-2">
        <p>
          These general terms of use (the "GTU") govern your use and access,
          either as an individual or a single entity ("You" or "Your" as
          applicable), to the website available at the following URL address:{' '}
          <a href="/" target="_blank" rel="noopener noreferrer">
            https://www.octoly.com/
          </a>{' '}
          (the "Site").
        </p>
        <p>
          For the purposes of the GTU, unless otherwise noted, all references to
          "Skeepers" will therefore include Videoagency, Skeepers, Inc. and
          their affiliates.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Site Presentation</p>
        <p>
          The Site is an interface of presentation and access to a platform (the
          "Platform") developed by Skeepers and operated under the brand
          Skeepers to enable partners (the "Partners") which own or
          commercialize products and/or services (such as, without limitation:
          cosmetics and video games) to connect with some creators which are
          registered with Skeepers (the "Creators") in order for them to sample
          the Partners’ Products, and to post a review of such sampling on their
          youtube and/or instagram account.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          2. Access to the Site and the Platform
        </p>
        <p className="tc-neutral900 ml-16">2.1. Users of the Site</p>
        <p>
          By accessing and using the Site, You expressly and unconditionally
          agree to the terms of the GTU in particular of the{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>
          . If You are accessing and/or using the Site as a single entity, You
          represent to Skeepers that You have all necessary corporate or
          equivalent authority and power to agree to the GTU which You agree
          shall be binding on the corporation, partnership, association or other
          entity in whose name You are using and accessing the Site as a user.
        </p>

        <p className="tc-neutral900 ml-16">
          2.2. Partners using and/or accessing the Platform
        </p>
        <p>
          You can subscribe to the Platform as a Partner by executing an
          agreement with Skeepers enabling them to notably analyze the data
          related to Creators’ activities on social media, and to measure the
          social influence of the Creators and their competence in certain
          specific domains (the "Services").
        </p>

        <p className="tc-neutral900 ml-16">
          2.3. Creators using and/or accessing the Platform
        </p>
        <p>
          You can subscribe to the Platform as a Creator by accepting the
          specific terms and conditions related to Your use of the Platform as a
          Creator (available at the following URL address:
          <a
            href="/conditions-for-contributors"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://app.im.skeepers.io/conditions-for-contributors/
          </a>
          ). As a Creator, You undertake to complete the subscription form with
          up to date and accurate details, and to update them in case of any
          change. The subscription data and any other information You indicate
          when subscribing are governed by the{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>
          .
        </p>
        <p>
          Skeepers uses Youtube’s API notably to authenticate and link Your
          Youtube channel to Your Creator account on the Platform, therefore by
          using the Platform, You agree to be bound by the YouTube Terms of
          Service available at the following URL address:
          <a
            href="https://www.youtube.com/t/terms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms/
          </a>
          .
        </p>

        <p className="tc-neutral900 ml-16">2.4. Restrictions</p>
        <p>
          Skeepers reserves the right, at its sole discretion, to limit and/or
          forbid access to the Services, the Site and/or the Platform, and/or to
          terminate any Partner and/or Creator account which violates the GTU,
          applicable laws and/or any third party right such as, without
          limitation, any intellectual property right.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">3. Intellectual Property</p>
        <p className="tc-neutral900 ml-16">
          3.1. Regarding the Site, the Platform and Skeepers’ trademarks
        </p>
        <p>
          As a User, a Partner and/or a Creator, You acknowledge and agree that
          the Site, the Platform and the Services may contain elements,
          materials and content (the "Content") copyrighted and/or protected by
          patent and/or intellectual property laws.
        </p>
        <p>
          You are not authorized, without Skeepers’ prior consent, to modify,
          copy, rent, share, sell, distribute or create any derivative work from
          the Content of the Site and/or of the Platform, in whole or in part,
          nor to proceed to nor use the data extraction systems and/or data
          collection systems.
        </p>
        <p>
          The name and logos of Skeepers are registered trademark owned by
          Skeepers (collectively « Skeepers’ Trademarks"). The other names and
          logos of Skeepers’ products and services used in the scope of the
          Services are trademarks owned by their respective owners that may or
          may not be affiliated to Skeepers.
        </p>
        <p>
          Nothing in the GTU nor any content of the Services should be construed
          as granting, explicitly or not, any license or right to use Skeepers’
          Trademarks, without Skeepers’ written authorization in such case.
        </p>

        <p className="tc-neutral900 ml-16">
          3.2. Regarding third party content
        </p>
        <p>
          Partners and/or Creators may upload trademarks, materials,
          photographic and/or video content (together the "Third Party Content")
          via their Skeepers account under their sole liability.
        </p>
        <p>
          In no event shall Skeepers be liable, in any manner whatsoever, of
          Third Party Content uploaded on the Site and/or the Platform,
          including, without limitation, in the event of a claim arising from a
          Third Party Content, an error and/or omission related to a Third Party
          Content, or for any loss or damage resulting from and/or arising from
          the use of a Third Party Content.
        </p>
        <p>
          Skeepers does not monitor the Site and/or the Platform but reserves
          the right to remove any Third Party Content which violates the GTU
          and/or any applicable law, including any intellectual property law,
          after having obtained acknowledgement of such violation. To that
          respect, Skeepers invites all Users, Partners and/or Creators to
          contact Skeepers in the event where such User, Partner and/or Creator
          would have knowledge that a Third Party Content hosted on the Site
          and/or the Platform violates one of his rights and/or applicable laws
          by contacting us{' '}
          <a
            href="https://skeepers-octoly.zendesk.com/hc/en-150/requests/new?ticket_form_id=5486073315740"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
          and by following any legal requirement as per applicable rules to
          takedown requests for illicit content. Upon receipt of a valid
          takedown request as per applicable laws, Skeepers will promptly remove
          any Third Party Content concerned by such request.
        </p>
        <p>
          You must evaluate and bear risks related to the use of a Third Party
          Content notably with regards to the accuracy, completeness and
          usefulness of such Third Party Content.
        </p>
        <p>
          You acknowledge and agree that any question, comment, suggestion,
          enhancement, idea, and other information regarding the Services (the «
          Propositions") that you may supply to Skeepers are not confidential
          information and that Skeepers is entitled to use and disclose, without
          any restriction, the Propositions for any purpose, whether commercial
          or not, without any recognition nor consideration.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">4. Site availability</p>
        <p>
          Skeepers makes no warranty with regards to the Site and/or Platform’s
          availability. Skeepers reserves the right to modify, suspend and/or
          delete any and all element of the Site and/or the Plaform, and any
          information that it may content at any time without any notification.
          Therefore, in no event shall Skeepers be liable for any actual or
          alleged damage incurred directly or indirectly, by any User, Creator
          and/or Partner, in relation with the connection, consultation and/or
          use of information supplied by the Site and/or the Platform.
        </p>
        <p>
          If Your use of the Site is blocked by Skeepers (notably by blocking
          Your IP address), You agree not to implement any measure aiming to
          circumvent such blocage (notably my hiding Your IP address or by using
          the IP address of a third party).
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">5. Amemdnent of the GTU</p>
        <p>
          Skeepers reserves the right to amend the GTU and the{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>{' '}
          at any time. In such event, the amendments will be notified to You
          with a special banner within the Site. You acknowledge and agree by
          using and/or accessing the Site after the amendment date, You will be
          deemed having fully consented to the GTU and the{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            privacy policy
          </a>{' '}
          as amended.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">6. Litigation</p>
        <p>
          The Site and the GTU are governed by French law, wherever You are
          accessing and/or using the Site and/or the Platform from. In the event
          of a dispute regarding the GTU, the courts of Paris, France, shall be
          solely competent to hear such dispute.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline uppercase">
          QUESTIONS? PROBLEMS? SUGGESTIONS?
        </p>
        <p>
          Please contact us{' '}
          <a
            href="https://skeepers-octoly.zendesk.com/hc/en-150/requests/new?ticket_form_id=5486073315740"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>{' '}
          or by postal mail at Skeepers, Octoly Inc. 244 Fifth Avenue, Suite
          D61, New-York, NY 10001 - U.S. to inform us of any breach of the GTU
          and/or to ask us any information regarding the GTU and/or the
          Services.
        </p>
      </div>
    </>
  )
}

export default TermsEN
